import { Link } from 'react-router'
import { Badge, Card, CardHeader, Empty, PageHeader } from '@concours/ui'
import { ShieldCheck } from 'lucide-react'
import { when } from '../../lib/competition-types'
import { RANKING_VARIANT, useQueue } from '../../lib/results'

/** Autorité : classements à approuver, à publier, et demandes de rectification. */
export function ApprovalsPage() {
  const queue = useQueue()
  const q = queue.data
  const toApprove = q?.rankings.filter((r) => r.status === 'under_control') ?? []
  const toPublish = q?.rankings.filter((r) => r.status !== 'under_control') ?? []
  const row = (r: NonNullable<typeof q>['rankings'][number]) => (
    <li key={r.id}>
      <Link to={`/resultats/${r.stage.id}`} className="queue-link">
        <span className="stack" style={{ gap: 2 }}>
          <strong>
            {r.stage.label} — {r.competition.title}
          </strong>
          <span className="muted">
            Version {r.version}
            {r.submittedAt && ` · transmise le ${when(r.submittedAt)}`}
            {r.approvedAt && ` · approuvée le ${when(r.approvedAt)}`}
          </span>
        </span>
        <Badge variant={RANKING_VARIANT[r.status]}>{r.statusLabel}</Badge>
      </Link>
    </li>
  )
  return (
    <>
      <PageHeader
        eyebrow="Résultats"
        title="Approbations et publications"
        description="Classements transmis au contrôle, résultats approuvés à publier, demandes de rectification."
      />
      <div className="stack" style={{ gap: 'var(--space-4)' }}>
        <Card>
          <CardHeader title={`À approuver (${toApprove.length})`} />
          {toApprove.length ? (
            <ul className="queue-list">{toApprove.map(row)}</ul>
          ) : (
            <Empty
              icon={<ShieldCheck aria-hidden="true" />}
              title="Aucun classement en attente d’approbation"
            />
          )}
        </Card>
        <Card>
          <CardHeader title={`À publier (${toPublish.length})`} />
          {toPublish.length ? (
            <ul className="queue-list">{toPublish.map(row)}</ul>
          ) : (
            <Empty title="Aucun résultat approuvé en attente de publication définitive" />
          )}
        </Card>
        <Card>
          <CardHeader title={`Rectifications demandées (${q?.rectifications.length ?? 0})`} />
          {q?.rectifications.length ? (
            <ul className="queue-list">
              {q.rectifications.map((r) => (
                <li key={r.id}>
                  <Link to={`/resultats/${r.stage.id}`} className="queue-link">
                    <span className="stack" style={{ gap: 2 }}>
                      <strong>
                        {r.stage.label} — {r.competition.title}
                      </strong>
                      <span className="muted">{r.reason}</span>
                    </span>
                    <Badge variant="warning">Demandée le {when(r.requestedAt)}</Badge>
                  </Link>
                </li>
              ))}
            </ul>
          ) : (
            <Empty title="Aucune demande en cours" />
          )}
        </Card>
      </div>
    </>
  )
}
